<template>
    <div><!-- 招標案件查詢 -->
        <SearchBar />
        <CCard>
            <CCardBody>
                 <div class="table-container">
                    <vue-bootstrap4-table class="" 
                        :rows="purchaseSearchObj.rows" 
                        :columns="columns" 
                        @on-change-query="onChangeQuery"
                        :total-rows="purchaseSearchObj.totalCount"
                        :config="config" :classes="classes" >
                        <template v-if="isTw" slot="empty-results">
                            查無結果
                        </template>
                        <template v-if="isTw" slot="pagination-info" slot-scope="props">
                            {{paginationInfoTwText(props)}}
                        </template>
                        <template slot="func" slot-scope="props">
                            <button class="btn btn-sm btn-success mr-2" @click="supplier(props.row)">{{supplierFuncText(props.row)}}</button>
                        </template>
                    </vue-bootstrap4-table>
                </div>            
            </CCardBody>
        </CCard>

    </div>    
</template>
<script>
import SearchBar from './SearchBar'
import { mapGetters,mapActions } from 'vuex'
export default {
    components: {
        SearchBar,
    },
    data() {
        return {                    
            columns: [
                { label: this.i18n('PurchaseTableHeader.FactoryType'), name: "factoryId",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.StartDate'), name: "startDate",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.QuoteNo'),name: "quoteNo",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.RequestName'), name: "requestName",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.RequestType'),name: "requestType",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.RequestWay'),name: "requestWay",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.NotifySupervisor'),name: "notifySupervisor",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.Deadline'),name: "deadline",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.Purchaser'),name: "purchaserName",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.CaseClosed'),name: "caseClosed",row_text_alignment: "text-left"},                
                { label: this.i18n('PurchaseTableHeader.QuotationDate'),name: "quotationDate",row_text_alignment: "text-left" },
                { label: this.i18n('PurchaseTableHeader.Function'),name: "func",slot_name: 'func'}
            ],
            rows: [],
            totalNo: 0,
            config: {
                card_mode: false,
                show_refresh_button: false,
                show_reset_button: false,
                per_page: 10,
                server_mode: true, // by default false
                per_page_options: [10, 25, 50],
                global_search: {
                    visibility: false
                },
                // checkbox_rows: true,
            },
            classes: {
                // table: 'table-light table-striped',
                // via: 'table-danger'
            },
        }
    },
    props : {        
    },
    watch: {
        lang: function() {            
            this.columns = [
                { label: this.i18n('PurchaseTableHeader.FactoryType'), name: "factoryId",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.StartDate'), name: "startDate",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.QuoteNo'),name: "quoteNo",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.RequestName'), name: "requestName",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.RequestType'),name: "requestType",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.RequestWay'),name: "requestWay",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.NotifySupervisor'),name: "notifySupervisor",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.Deadline'),name: "deadline",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.Purchaser'),name: "purchaserName",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.CaseClosed'),name: "caseClosed",row_text_alignment: "text-left"},                
                { label: this.i18n('PurchaseTableHeader.QuotationDate'),name: "quotationDate",row_text_alignment: "text-left" },
                { label: this.i18n('PurchaseTableHeader.Function'),name: "func",slot_name: 'func'}
            ]
        }
    },
    mounted() {        
        this.getProcurementOfficers();
    },
    computed: {
        ...mapGetters('purchaseModule', ['procurementOfficerList','purchaseSearchObj']),
        isAdmin (){           
            return false;
        }
    },
    methods: {
        ...mapActions('purchaseModule', ['searchPurchase','getProcurementOfficers']),                
        i18n (keyStr){
            return this.$t(keyStr);
        },
        onChangeQuery(queryParams) {                        
            let search =  {};
            ({StartDateBegin : search.StartDateBegin, StartDateEnd : search.StartDateEnd,DeadlineBegin : search.DeadlineBegin,DeadlineEnd : search.DeadlineEnd,QuoteNoBegin : search.QuoteNoBegin,QuoteNoEnd : search.QuoteNoEnd,RequestType : search.RequestType,PurchaserNo : search.PurchaserNo,CaseClosed : search.CaseClosed } = this.purchaseSearchObj.filter);            
            search.pageSize=queryParams.per_page;
            search.pageIndex=queryParams.page;
            //須用此方式提供 語系對應功能函數            
            search.func = (key) => this.$t(key);
            search.fixDate = this.fixDate;
            this.searchPurchase(search);            
        },
        paginationInfoTwText(props){            
            const {filter ,totalCount} = this.purchaseSearchObj;
            let startRecNo = 0;
            let endRecNo = 0;
            if(totalCount && totalCount > 0 && filter && filter.pageSize && filter.pageIndex){
                startRecNo = 1 + (filter.pageIndex - 1 ) * filter.pageSize;
                endRecNo = startRecNo + filter.pageSize -1;
                if(endRecNo > totalCount){
                    endRecNo = totalCount ;
                }
                return `第 ${startRecNo}筆 ~ 第 ${endRecNo}筆資料列(共${props.originalRowsLength}筆)`;
            }else{
                return '無任何資料列';
            }            
        },
        supplierFuncText (item){ 
            const today= new Date().yyyymmdd();            
            if(item.caseClosedCode === 'N' && (item.deadline && item.deadline > today)){
                return this.i18n('Buttons.Supplier');
            }else{
                //報價截止日期<系統當日時，供應商不得於ROE平台上進行報價，或案件已經關閉
                return this.i18n('Buttons.DetailInfo');
            }
        },
        supplier(item) { // 報價      
            const id = item.guid;  
            sessionStorage.setItem('purchaseId', id);
            this.$router.push('/supplier')
            //this.$store.dispatch('alertMessageModule/updateMessage', { message: '已成功登入', status: 'success' });
        },   
    }
}
</script>
<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}
</style>

